import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Nav = () => {
    const [active, setActive] = useState(false)

    const handleClick = () => {
        setActive(!active)
    }

    return (
        <NavContainer>
            <div
                className={active ? 'btn active' : 'btn'}
                onClick={handleClick}
            ></div>

            <div className={active ? 'nav-screen active' : 'nav-screen'}>
                <p className={active ? 'brand active' : 'brand'}>Naheel</p>
                <p className={active ? 'title active' : 'title'}>Menu</p>
                <div
                    className={
                        active ? 'nav-container active' : 'nav-container'
                    }
                >
                    <Link to='/' onClick={() => setActive(!active)}>
                        <p className={active ? 'nav-item active' : 'nav-item'}>
                            Home
                        </p>
                    </Link>
                    <Link to='/work' onClick={() => setActive(!active)}>
                        <p className={active ? 'nav-item active' : 'nav-item'}>
                            Work
                        </p>
                    </Link>
                    <Link to='/about' onClick={() => setActive(!active)}>
                        <p className={active ? 'nav-item active' : 'nav-item'}>
                            About
                        </p>
                    </Link>
                    <Link to='/contact' onClick={() => setActive(!active)}>
                        <p className={active ? 'nav-item active' : 'nav-item'}>
                            Contact
                        </p>
                    </Link>
                </div>
            </div>
        </NavContainer>
    )
}

export default Nav

const NavContainer = styled.div`
    z-index: 100;
    .btn {
        position: fixed;
        width: 6rem;
        height: 3rem;
        padding: 0.5rem;
        z-index: 100;

        top: 6vh;
        right: 4%;

        cursor: pointer;

        transition: all 400ms cubic-bezier(0.4, 0, 0, 0.8);
    }

    .btn.active {
        transform: rotate(180deg);
    }

    .btn::before {
        content: ' ';
        height: 3px;
        width: 1.6rem;
        background-color: var(--color-dark);
        position: absolute;
        left: 50%;
        top: 38%;
        transform: translateX(-50%);
        transition: all 400ms cubic-bezier(0.4, 0, 0, 0.8);
    }

    .btn::after {
        content: ' ';
        height: 3px;
        width: 1.2rem;
        background-color: var(--color-dark);
        position: absolute;
        left: 46%;
        top: 56%;
        transform: translateX(-50%);
        transition: all 400ms cubic-bezier(0.4, 0, 0, 0.8);
    }

    .btn.active::before {
        transform: rotate(-45deg);
        width: 1.4rem;
        left: 42%;
        top: 46%;
        background-color: var(--color-light);
    }

    .btn.active::after {
        transform: rotate(45deg);
        width: 1.4em;
        left: 42%;
        top: 46%;
        background-color: var(--color-light);
    }

    .nav-screen {
        height: 100vh;
        width: 100%;
        background-color: var(--color-dark);
        position: fixed;
        z-index: 10;
        transition: all 600ms cubic-bezier(0.4, 0, 0, 0.8);
        top: 0;
        transform: translateY(-100%);
        transition-delay: 300ms;
    }

    .nav-screen.active {
        transform: translateY(0%);
    }

    .nav-container {
        position: absolute;
        left: 6%;
        bottom: 14%;
    }

    .title {
        font-size: 14vw;
        font-weight: 700;
        position: absolute;
        top: 12%;
        left: 5%;
        color: var(--color-light);
        margin: 0;
        text-shadow: -1px 0 0 #d5cdc4, 0 1px 0 #d5cdc4, 1px 0 0 #d5cdc4,
            0 -1px 0 #d5cdc4;
        text-transform: uppercase;
        transition: all 800ms;
        transform: translateY(-40%);
        opacity: 0;
    }

    .title.active {
        transition-delay: 600ms;
        transform: translateY(0%);
        opacity: 1;
    }

    .brand {
        color: var(--color-light);
        position: absolute;
        top: 8%;
        left: 6%;
        font-size: 0.8rem;
        letter-spacing: 2px;
        text-transform: uppercase;
        transition: all 800ms;
        transform: translateY(-40%);
        opacity: 0;
    }

    .brand.active {
        transition-delay: 800ms;
        transform: translateY(0%);
        opacity: 1;
    }

    .nav-item {
        margin: 0;
        color: var(--color-light);
        font-size: 1.8rem;
        line-height: 4rem;
        width: 20rem;
        transition: all 600ms ease;
        cursor: pointer;
        transform: translateY(-80%);
        opacity: 0;
    }
    .nav-item.active {
        transition-delay: 800ms;
        transform: translateY(0%);
        opacity: 1;
    }
`
